import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const SellerIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--seller-icon')}
    data-icon={icon}
    width="45"
    height="45"
    viewBox="0 0 45 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <circle id="path-1" cx="22.5" cy="22.5" r="22.5" />
      <filter id="filter-3">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g id="DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="FPO-Seller-Profile-Icon-Generic">
        <g id="Emily-Profile-Image">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="Oval" fill="#000000" xlinkHref="#path-1" />
        </g>
        <g filter="url(#filter-3)" id="Account">
          <g transform="translate(14.062500, 13.125000)">
            <ellipse
              id="Oval"
              stroke="#000000"
              strokeWidth="1.5"
              cx="8.353125"
              cy="5.05027174"
              rx="4.55625"
              ry="4.62228261"
            />
            <path
              d="M16.70625,19.2595109 C16.70625,15.4302866 12.9664286,12.326087 8.353125,12.326087 C3.73982145,12.326087 0,15.4302866 0,19.2595109"
              id="Shape"
              stroke="#000000"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SellerIcon;
